export const HF_CONFIG = {
  CLIENT_ID: "143c924d-5fa8-47b7-8ea9-d22b5a2c9212",
  STORAGE_KEY: "hf_oauth",
  SCOPE: "openid profile",
  PROD_URL: "https://thefinai-open-greek-finance-llm-leaderboard.hf.space",
  DEV_URL: "http://localhost:7860"
}; 
